import React from 'react'
import {
  Container,
  Header,
} from 'semantic-ui-react'

const Terms = () => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>Terms of Service</Header>
    <p>
      This web application was developed by <a href='http://www.inf.usi.ch/faculty/hauswirth/'>Matthias Hauswirth</a>.
      It is hosted on his personal web page
      at <a href='http://www.usi.ch/'>Università della Svizzera italiana (USI)</a> in Switzerland.
    </p>
    <p>
      We provide this application as a service for the community,
      in the hope that it will be helpful.
      There are and will never be any commercial interests behind this,
      and there will never be any ads.
    </p>
    <p>
      Use this web application at your own risk.
      If you spend hours mapping your curriculum,
      and the application then loses all the data,
      we're very sorry, but we won't be responsible.
    </p>
    <p>
      Anything you do in this web application happens strictly within your browser.
      The application does not communicate with the server
      except to download the files making up the application itself.
    </p>
  </Container>
)

export default Terms